export const complaintTypeData = {
  buttons: [
    {
      label: 'Goods supplied',
      id: 'goods-supplied',
    },
    {
      label: 'Poor workmanship',
      id: 'poor-workmanship',
    },
  ],
  title:
    'Is your complaint specifically about damaged or faulty goods, or the poor workmanship of the trader?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/61dddee5ab83-tooliconpaint.jpg',
  },
}
